import { RequestAction } from '@redux-requests/core';
import { gql } from '@redux-requests/graphql';
import { AccountConstants } from '../constants';

export const getAccount = (): RequestAction => ({
  type: AccountConstants.ACCOUNT,
  request: {
    query: gql`
      {
        getAccount {
          developer {
            email
            firstName
            lastName
            phone {
              phone
            }
            companyName
            website
          }
        }
      }
    `,
  },
  meta: {
    getData: ({ getAccount }) => getAccount?.developer || {},
  },
});
